import React from 'react';

import './Input.css';
 
const input = (props) => (
  <div className="input">
    {props.label && (
      <label
        htmlFor={props.id}
        className="uk-form-label uk-flex uk-flex-between"
      >
        {props.label}
        {props.required && <span className="uk-form-label__required"></span>}
        {props.unit && (
          <span className="uk-float-left uk-padding-medium-left">
            {props.unit}
          </span>
        )}
      </label>
    )}
    <div
      className={[
        "field-wrapper",
        props.validationError === "" ? "" : "has-error",
      ].join(" ")}
    >
      {props.control === "input" && (
        <input
          className={[
            "mn-content-input__origin",
            !props.valid ? "invalid" : "valid",
            props.touched ? "touched" : "untouched",
          ].join(" ")}
          type={props.type}
          id={props.id}
          //required={props.required}
          value={props.value}
          placeholder={props.placeholder}
          onChange={(e) =>
            props.onChange(props.id, e.target.value, e.target.files)
          }
          onBlur={props.onBlur}
        />
      )} 
      {props.control === "textarea" && (
        <textarea
          className={[
            "uk-textarea uk-textarea--attr mn-content-textarea__origin",
            !props.valid ? "invalid" : "valid",
            props.touched ? "touched" : "untouched",
          ].join(" ")}
          id={props.id}
          placeholder={props.placeholder}
          rows={props.rows}
          cols={props.cols}
          //required={props.required}
          value={props.value}
          onChange={(e) => props.onChange(props.id, e.target.value)}
          onBlur={props.onBlur}
        />
      )}
      {!(props.validationError === "") && (
        <div id={props.id} className="error error-msg">
          {props.validationError}
        </div>
      )}
    </div>
    <div></div>
  </div>
);

export default input;
